<!--SKU编辑  -->
<template>
	<el-dialog title="添加客商" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false"
		width="780px" :before-close="cancle">
		<span slot="title" class="flex flex-middle">
			<div class="title">添加客商</div>
			<div class="flex ml15">
				<el-input v-model.trim="agentName" class="w190" size="small" placeholder="客商名称" maxlength="16" clearable>
				</el-input>
				<el-input v-model.trim="ncDrawerName" class="w190 ml10" size="small" placeholder="SAP开票单位" maxlength="16" clearable>
				</el-input>
				<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch" alt="">
			</div>
		</span>
		<div class="form-box">
			<el-table
				class="mt10" border
				ref="multipleTable"
				:data="tableData"
				:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
				v-el-table-infinite-scroll="tableLoad"
				:height="height"
				:infinite-scroll-distance="50"
				infinite-scroll-immediate="false"
				@selection-change="handleSelectionChange"
				style="width: 100%">
				<el-table-column type="selection" width="50" align="center">
				</el-table-column>
				<el-table-column :show-overflow-tooltip="true" width="150" prop="agentCode" label="客商编号">
				</el-table-column>
				<el-table-column :show-overflow-tooltip="true" prop="agentName" label="客商名称">
				</el-table-column>
				<el-table-column :show-overflow-tooltip="true" width="150" prop="sapNo" label="客商SAP编号">
				</el-table-column>
				<el-table-column :show-overflow-tooltip="true"  prop="ncDrawerName" label="SAP开票单位">
				</el-table-column>
				<el-table-column :show-overflow-tooltip="true" width="90" prop="address" label="结算方式">
					<template slot-scope="scope">
						<span>{{settlementType[scope.row.settlementType]}}</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<span slot="footer" class="dialog-footer mt10">
			<el-button size="small" @click="cancle()">取 消</el-button>
			<el-button size="small" type="primary" @click="handleSubmit()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { debounce } from '@/utils/debounce'
	export default {
		data() {
			return {
				dialogVisible: false,
				height: 400,
				settlementType: {
					'0': '现金',
					'1': '账期',
					'2': '其它',
					'9': '自贩'
				},
				agentName: '',
				ncDrawerName:"",
				currentData: null,
				pageNo: 0,
				pageSize: 20,
				tableData: [],
				infiniteFlag: false,
			}
		},
		created() {

		},
		methods: {
			init(dt) {
				this.dialogVisible = true;
				this.infiniteFlag=false
				this.currentData = dt;
				this.agentName = '';
				this.ncDrawerName = ''
				this.$nextTick(() => {
					this.pageNo = 1
					this.getAgentList();
				})
			},
			//  获取列表
			getAgentList(type) {
				if(this.infiniteFlag) {
					return
				}
				let that = this;
				that.$request.post(
					"agentList",
					true, {
						settlementType: 0,
						groupId: that.currentData.groupId,
						accountId: that.currentData.accountId,
						advancesFlag:'Y' ,
						pageNo: that.pageNo,
						pageSize: that.pageSize,
						agentName: that.agentName,
						ncDrawerName:that.ncDrawerName
					})
				.then((res) => {
					if (res) {
							if(res.data) {
							that.infiniteFlag = res.data.totalPage <= that.pageNo;
							}
						if(type == 'scroll') {
							that.tableData = that.tableData.concat(res.data.list);
						}else {
							that.tableData = res.data.list;
						}
					}
				})
			},
			// 表格滚动加载
			tableLoad:debounce(function() {
				this.pageNo++;
				this.getAgentList('scroll');
			},100,true),
			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			handleSearch() {
				this.pageNo = 1;
				this.infiniteFlag = false;
				this.$nextTick(() => {
					this.getAgentList();
				})
				if (this.tableData.length > 0) {
					this.$refs.multipleTable.clearSelection();
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}
			},
			handleSubmit:debounce(function() {
				if(this.dialogVisible == false) {
					return
				}
				let agents = [];
				if(this.multipleSelection.length > 0) {
					this.multipleSelection.forEach(item => {
						agents.push(item.agentId);
					})
				}
				let that = this;
				that.$request.post(
					'preaccountAgentAdd',
					true, {
						accountId: that.currentData.accountId,
						agentIds: agents
					}
				)
				.then((res) => {
					that.dialogVisible = false;
					if (res) {
						that.$emit('getAgentList');
						that.$message.success('保存成功');
					}
				})
			},1000,true),
			// 取消
			cancle() {
				this.dialogVisible = false
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>

	/deep/ .el-dialog__body {
		padding: 0px 10px;
	}
	.el-table__body-wrapper {
		overflow-y: scroll !important;
	}
		.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 5px;
		}

		/deep/ td {
			padding: 5px;
		}

	}

</style>
